import {Injectable} from '@angular/core';
import {ShipmentListResponse} from '../shipment-list-response';
import { ActivatedRouteSnapshot, convertToParamMap, ParamMap } from '@angular/router';
import {ShipmentListService} from '../shipment-list.service';

import shortUuid from 'short-uuid';
import {ShipmentQueryParameters} from '../shipment-query-parameters';
import {Observable} from 'rxjs/internal/Observable';

@Injectable()
export class AssignShipmentsListResolver  {
  constructor(private shipmentListService: ShipmentListService) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<ShipmentListResponse> {
    const params = convertToParamMap(route.queryParams);

    const page = params.has('page') ? params.get('page') : 1;
    const pageSize = params.has('pageSize') ? +params.get('pageSize') : 20;

    let carrierId: string = params.get('carrier');

    if (carrierId !== null) {
      carrierId = shortUuid().toUUID(carrierId);
    }

    let departmentId: string = params.get('department');

    if (departmentId !== null) {
      departmentId = shortUuid().toUUID(departmentId);
    }

    let offset = 0;

    if (page !== undefined) {
      offset = pageSize * (+page - 1);
    }

    const parameters: ShipmentQueryParameters = {
      carrierId: carrierId,
      departmentId: departmentId,
      offset: offset,
      count: pageSize,
      orderStatus: params.has('status') ? params.get('status') : 'Unassigned,Offer',
      includeShipmentsWithoutOrderBinding: false,
      sortBy: params.get('sortBy'),
      sortDirection: params.get('sortDirection'),
      number: params.get('search'),
      receiverName: params.get('search'),
      senderName: params.get('search'),
      updatedAfter: null,
      updatedUntil: null
    };

    return this.shipmentListService.getShipments(parameters);
  }
}
